/**
 * The handful of things both the person layer and the team layer need.
 *
 * It exists to keep `scenario.ts` and `squads.ts` from importing each other:
 * team operations are applied to the base overrides as well as to a scenario,
 * so they cannot live inside the scenario module.
 *
 * Not re-exported from `index.ts` — `OpError` is the only part of this that is
 * public API, and `scenario.ts` re-exports it.
 */
/** Thrown for user-correctable problems. Servers map this to a 400, MCP returns the message. */
export class OpError extends Error {
    constructor(message) {
        super(message);
        this.name = 'OpError';
    }
}
export function randomId() {
    // Works in Node and in the browser without pulling in DOM lib types.
    const cryptoObj = globalThis.crypto;
    if (typeof cryptoObj?.randomUUID === 'function')
        return cryptoObj.randomUUID().slice(0, 8);
    return Math.random().toString(36).slice(2, 10);
}
export function nowIso() {
    return new Date().toISOString();
}
/** Split `<kind>:<rest>` change ids, which are deterministic and so always parseable. */
export function splitChangeId(changeId) {
    const index = changeId.indexOf(':');
    if (index < 0)
        throw new OpError(`Malformed change id "${changeId}".`);
    return [changeId.slice(0, index), changeId.slice(index + 1)];
}
//# sourceMappingURL=util.js.map